import angular from "angular";

angular
    .module('app')
    .component('courseTrainingProgram', {
        template: require('./course-training-program.html'),
        controller: ['$uibModal', '$http', '$sce', '$timeout', '$interval', 'Notifier', controller],
        bindings: {
            course: '<',
            activeLesson: '<',
            courseStatus: '@',
        }
    });

function controller(Upload, $uibModal, $http, $sce, $timeout, $interval, Notifier) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.lesson = $ctrl.activeLesson;
    };

}
